import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
import Stat from "../../../components/shared/stat";
import { Card, CardContent, CardHeader } from "@mui/material";
import classes from "./communication.module.scss";

const CommunicationPage = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title="وضعیت ارتباط سرویس‌ها در ده روز گذشته"
            action={
              <ul className={classes.statusList}>
                <li className={classes.item}>تعداد سرویس فعال : 5</li>
              </ul>
            }
          />
        </Card>
      </Grid>

      <Grid xs={12} md={6} lg={3}>
        <Stat
          type="navy"
          value={5}
          unit="%"
          label="سرویس انرژی(مدیریت شبکه)"
          hasShowMore={true}
          showMore={{ link: "/setting/1234", text: "مشاهده جزئیات" }}
        />
      </Grid>
      <Grid xs={12} md={6} lg={3}>
        <Stat
          type="info"
          value={98}
          unit="%"
          label="سرویس انرژی (دیتالیک)"
          hasShowMore={true}
          showMore={{ link: "/setting/1234", text: "مشاهده جزئیات" }}
        />
      </Grid>
      <Grid xs={12} md={6} lg={3}>
        <Stat
          type="success"
          value={96}
          unit="%"
          label="سرویس خاموشی"
          hasShowMore={true}
          showMore={{ link: "/setting/1234", text: "مشاهده جزئیات" }}
        />
      </Grid>
      <Grid xs={12} md={6} lg={3}>
        <Stat
          type="primary"
          value={67}
          unit="%"
          label="سرویس فهام (دیتالیک)"
          hasShowMore={true}
          showMore={{ link: "/setting/1234", text: "مشاهده جزئیات" }}
        />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader title="ادامه" />
          <CardContent>content</CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CommunicationPage;
